var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiyWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 165C135.899 165 165 135.899 165 100C165 64.1015 135.899 35 100 35C64.1015 35 35 64.1015 35 100C35 135.899 64.1015 165 100 165Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.905 49H37.0949C34.2781 49 32 51.4024 32 54.3719V143H167V54.3719C167 51.4024 164.722 49 161.905 49Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 138V54.0861C32 51.2742 34.2781 49 37.0949 49H161.905C164.722 49 167 51.2742 167 54.0861V138",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.901 54H43.0987C40.2828 54 38 56.2816 38 59.0961V126.904C38 129.718 40.2828 132 43.0987 132H156.901C159.717 132 162 129.718 162 126.904V59.0961C162 56.2816 159.717 54 156.901 54Z",
    fill: "#ECEEF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179 138H117.84L115.292 140.6H84.7083L82.1596 138H21V143.2C21 147.486 24.437 151 28.6459 151H171.354C175.578 151 179 147.509 179 143.2V138Z",
    fill: "#36A635",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0068 106.92H93.6136",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.667 75.8701L110 107.537L102 109.137L103.6 101.137L135.267 69.47C135.893 68.8433 136.907 68.8433 137.533 69.47L141.673 73.6101C142.3 74.2367 142.3 75.2501 141.673 75.8767L141.667 75.8701Z",
    fill: "#AEAEAE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.187 73.6536L106.521 105.32L98.5205 106.92L100.121 98.9202L131.787 67.2536C132.414 66.6269 133.427 66.6269 134.054 67.2536L138.194 71.3936C138.821 72.0203 138.821 73.0336 138.194 73.6603L138.187 73.6536Z",
    fill: "#36A635",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiyWebsite);
export default __webpack_public_path__ + "static/media/DIYWebsite.b3c4af957dcf664d01d570c5cf95e9cb.svg";
export { ForwardRef as ReactComponent };